import * as THREE from 'three';
import { Vector2, Vector3 } from 'three';

export class DropItem {
	constructor(x, y, model, sceneRef) {
		this.pos = new Vector3(0, 0, 0);
		this.blacklisted = false;
		this.rotation = Math.random() * 0.06 + 0.02;
		this.mesh;
		this.astBox;
		this.type = '';

		return this;
	}

	update() {
		this.mesh.position.copy(this.pos);
		this.mesh.rotateZ(this.rotation * 0.6);
		//this.mesh.rotateZ(this.rotation * 0.2);
	}

	reset() {
		this.blacklisted = false;
	}
}
